module.exports = __webpack_public_path__ + "img/pr-4.aa45115a.png";